var $80e1f5b9b1708516$exports = {};
$80e1f5b9b1708516$exports = {
    "endTime": `Hora final`,
    "startTime": `Hora inicial`,
    "time": `Hora`
};


export {$80e1f5b9b1708516$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
